var Mn = require('backbone.marionette'),
    $ = window.jq = require('jquery'),
    helper = require('./lib/helpers'),
    $win = $(window),
    Application = Mn.Application.extend({
        el: function () {
            return this.layout.$el.find('#cotacao-content');
        },
        go: function (view, top) {
            var self = this;
            this.layout.go(view, function(){
                self.sections =  $('section[data-anchor-scroll]');


                setTimeout(function(){
                    var hash = document.location.hash;
    
                    if (hash) {
                        $(window).scrollTop(0);
                        self.anchor(hash);
                    }
                }, 500);
            });
        },
        anchor: function (where) {
            helper.anchor(where);
        },
        onStart: function () {
            var self = this, last = false, fullvisible = false;

            var imageSrcArray = document.images;

            $(self.$el).addClass('cotacao-loading');

            helper.loadImages(imageSrcArray).then(
                function gotEm(imageArray) {
                    return imageArray.length;
                },
                function doh(err) {
                    console.log(err);

                    $(self.$el).removeClass('cotacao-loading');
                    $(self.$el).addClass('cotacao-loaded');
                    $('.cotacao-loading-bar', self.$el).addClass('cotacao-loading-bar--loaded');
                }
            ).then(
                function shout (count) {
                    $(self.$el).removeClass('cotacao-loading');
                    $(self.$el).addClass('cotacao-loaded');
                    $('.cotacao-loading-bar', self.$el).addClass('cotacao-loading-bar--loaded');

                    var hash = document.location.hash;

                    if (hash) {
                        $(window).scrollTop(0);
                        self.anchor(hash);
                    }
                    setTimeout(function(){
                        self.loaded = true;
                    }, 1000);
                }
            );

            $win
            .scroll(function () {
                var top = typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY, current;
                self.trigger('scroll', {top: top, width: $win.width(), height: $win.height()});
            })
            .resize(function () {
                var top = typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY;
                self.trigger('resize', {top: top, width: $win.width(), height: $win.height()});
            })
            .mousemove(function (e) {
                self.trigger('mousemove', {left: e.pageX, top: e.pageY});
            })
                .mousemove(function (e) {
                    self.trigger('mousemove', {left: e.pageX, top: e.pageY});
            })
            .keydown(function (e) {
                switch (event.key) {
                    case "Escape":
                        self.trigger('esc');
                        break;
                    default:
                        return; // Quit when this doesn't handle the key event.
                }
            });
            $(document)
                .on('mouseup', function () {
                    self.trigger('mouseup');
                })
                .on('mousemove', function (e) {
                    self.trigger('mousemove', {left: e.pageX, top: e.pageY});
                })
                .on('touchend', function () {
                    self.trigger('touchend');
                })
                .on('touchmove', function (e) {
                    self.trigger('touchmove', {left: e.touches[0].pageX, top: e.touches[0].pageY});
                })
            ;
        },
        initialize: function () {
            var self = this, last = false;
            this.sections =  $('section[data-anchor-scroll]', self.$el);

            $.fn.shuffle = function () {
                var j;
                for (var i = 0; i < this.length; i++) {
                    j = Math.floor(Math.random() * this.length);
                    $(this[i]).before($(this[j]));
                }
                return this;
            };

            $(window)
                .scroll(function () {
                    var top = typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY, current;
                    self.trigger('scroll', {top: top});
                    windowHeight = $(window).height();
                    windowWidth = $(window).width();

                    for (var i = 0; i < self.sections.length; i++) {
                        var el = computed = $(self.sections[i]);

                        if(el.attr('data-anchor-computed')){
                            computed = el.find(el.attr('data-anchor-computed'));
                        }

                        var eltop = el.position().top;

                        if (eltop - top <= ($(window).height()/4)) {
                            current = el;
                        }

                        if (el.hasClass('has-parallax')) {
                            var navHeight = $('.navigation', self.$el).innerHeight();
                            var sectionTopOnScreen = eltop + navHeight - top - windowHeight;
                            var sectionBottomOnTopScreen = eltop + windowHeight - (top + navHeight);

                            if (0 >= sectionTopOnScreen && sectionBottomOnTopScreen >= 0) {
                                var toTranslate = ((sectionTopOnScreen + windowHeight) / windowHeight) * 100;
                                toTranslate = 100 - toTranslate;

                                if (toTranslate >= 200) {
                                    toTranslate = 200;
                                } else if (toTranslate <= 0) {
                                    toTranslate = 0;
                                }

                                el.find('[data-parallax]').css({
                                    'transform': 'translateY('+toTranslate * .3+'%)'
                                });
                            }
                        }
                    }

                    var toAnimate = $('[data-to-animate]', self.$el);
                    for (var i = 0; i < toAnimate.length; i++) {
                        var el = $(toAnimate[i]);

                        var offset = typeof el.data('animate-offset') !== 'undefined' ? ((Number(el.data('animate-offset')) / 100) * windowHeight) : 0;
                        var dataOffsetMobile = typeof el.data('animate-offset-mobile') !== 'undefined' ? ((Number(el.data('animate-offset-mobile')) / 100) * windowHeight) : 0;

                        if (windowWidth <= 1000) {
                            offset = dataOffsetMobile !== 0 ? dataOffsetMobile : offset;
                        }

                        var eltop = el.offset().top + offset;

                        if (eltop - (top + (windowHeight * .8)) <= 0 ) {
                            if(!el.hasClass('cotacao-animate')){
                                el.addClass('cotacao-animate');
                                el.removeAttr('data-to-animate');

                                function defineAnimated(el) {
                                    el.addClass('cotacao-animated');
                                    el.trigger('cotacao-animated');
                                }

                                setTimeout(defineAnimated.bind(null, el), Number(el.data('animate-time')) || 1000);
                            }
                        }
                    }

                    if (current && current.attr('data-anchor-scroll') && current.attr('data-anchor-scroll') !== last) {
                        if(!self.loaded){
                            return;
                        }
                        
                        last = current.attr('data-anchor-scroll');
                        var menuLinks = $('.navigation__link', self.$el);

                        if(last === '#'){
                            document.location.hash = '!';
                            menuLinks.removeClass('active');
                            return;
                        }

                        document.location.hash = '#!' + last;
                        
                        // menuLinks.each(function(){
                        //     if(last == $(this).attr('href').replace('#!', '')){
                        //         $(this).addClass('active');

                        //         var pos = $(this).offset().left;
                        //         var scrollPos = $('.navigation__container', self.$el).scrollLeft();
                        //         var offset = parseInt($('.navigation', self.$el).css('padding-left'));

                        //         $('.navigation__container', self.$el).animate( {scrollLeft: (scrollPos + pos - offset)}, 100 );
                        //     }else{
                        //         $(this).removeClass('active');
                        //     }
                        // });
                    }
                })
                .resize(function () {

                    var top = typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY, current;
                    self.trigger('resize', {top: top, width: $(window).width(), height: $(window).height()});
                });
        },
    });

module.exports = new Application();



// WEBPACK FOOTER //
// ./resources/scripts/app.js